import React from 'react';
import { ButtonData } from '../../../components/buttonGroup/MultiSelectButtonGroup';
import './CourseMapLegend.css';

interface CourseMapLegendProps {
    scopes?: ButtonData[];
}

const CourseMapLegend: React.FC<CourseMapLegendProps> = ({ scopes }) => {
    if (!scopes) return null;

    // Same filter as the overlay — only show toggleable scope icons
    const TOGGLEABLE_KEYS = ['after_school', 'camps', 'events'];
    const items = scopes.filter((s) => s.key && TOGGLEABLE_KEYS.includes(s.key));

    if (items.length === 0) return null;

    return (
        <div className="course-map-legend">
            {items.map((item) => (
                <div key={item.key} className="course-map-legend__item">
                    {item.icon}
                    <span className="course-map-legend__label">{item.title}</span>
                </div>
            ))}
        </div>
    );
};

export default CourseMapLegend;